import React from 'react'

const RextroBanner = () => {
  return (
    <div>
      <img src="/assets/rextro-ad.png" alt="rextro advertisement" className="w-full" />
    </div>
  )
}

export default RextroBanner
